import * as React from "react";
import { NumericFormatProps, NumericFormat } from "react-number-format";

interface InputComponentPriceProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

export const InputComponentPrice = React.forwardRef<NumericFormatProps, InputComponentPriceProps>(
    function InputComponentPrice(props, ref) {
        const { onChange, ...other } = props;

        return (
            <NumericFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value
                        },
                    });
                }}
                decimalSeparator=","
                thousandSeparator="."
                prefix="R$ "
                decimalScale={2}
                fixedDecimalScale
            />
        );
    },
);
